export const REQUSITION_STATUS = {
  APPROVED: "APPROVED",
  PENDING: "PENDING",
  REJECTED: "REJECTED",
  DRAFT: "DRAFT",
};

export const PROCUREMENT_STATUS = {
  READY_FOR_TAG: "READY_FOR_TAG",
  READY_FOR_STOCK: "READY_FOR_STOCK",
};

export const STATUS = {
  ...REQUSITION_STATUS,
  ...PROCUREMENT_STATUS,
};
